import { Component, OnInit } from '@angular/core';
import { IonFab, LoadingController, ModalController, NavParams } from '@ionic/angular';
import { element } from '@angular/core/src/render3';
import utf8 from 'utf8';
import { DocumentService } from 'src/services/document.service';

@Component({
    selector: 'modal-detalhe-atendimento',
    templateUrl: 'modal-detalhe-atendimento-component.html',
    styleUrls: ['modal-detalhe-atendimento-component.scss']
})

export class ModalDetalheAtendimentoComponent implements OnInit {

    atendimento: any;
    detalhe: any;
    list: any;

    constructor(private modalController: ModalController,
                private navParams: NavParams,
                private document: DocumentService,
                private loadingCtrl: LoadingController) {
        this.atendimento = this.navParams.get('atendimento');


        const prontuario = {
            titulo: 'Consulta',
            responsavel: 'Luana Aparecida',
            cnsResponsavel: '0000.0000.0000.0000',
            cboResponsavel: '0000',
            responsavelAtentimento: 'Sim',
            observacoes: {
                peso: '80kg',
                altura: '1,76M',
                exporsicaoSubstcias: 'Outras',
            },
            internacao: {
                cid: 'Lorem ipsim',
                status: 'Lorem ipsim',
                ocorrencia: 'Lorem ipsim',
                resenteAdmissao: 'Lorem ipsim',
                estado: 'Lorem ipsim',
                curso: 'Lorem ipsim',
                categoriaDRG: 'Lorem ipsim',
                anotacao: 'easure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely ',
            },
            resumoInternacao: {
                procedimentoStatus: 'Concluído',
                procedimentoRealizado: 'Lorem ipsim',
                subtopic3: 'Lorem ipsim',
                codigo: 'Lorem ipsim',
                status: 'Lorem ipsim',
                formaFarmaceutica: 'Lorem ipsim',
                viaAdministracao: 'Lorem ipsim',
                doseEstruturada: 'Lorem ipsim',
                dose: 'Lorem ipsim',
                statusPrescricao: 'Lorem ipsim',
            },
            alta: {
                recomendacao: 'Lorem ipsim because those who do not know how to pursue pleasure rationa',
                desfecho: 'easure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely ',
            }
        };
    }


    ngOnInit() {
        // this.getDetalhe(this.atendimento);
    }

    getTitle(tipo) {
        if (tipo.toUpperCase() === 'ATENDIMENTO CLÍNICO') {
            return 'Registro de Atendimento Clínico';
        } else if (tipo.toUpperCase() === 'RESULTADO DE EXAMES') {
            return 'Resultado de Exame';
        } else if (tipo.toUpperCase() === 'SUMÁRIO DE ALTA') {
            return 'Internaçōes';
        } else if (tipo.toUpperCase() === 'REGISTROS DE VACINA') {
            return 'Registros de vacina';
        } else if (tipo.toUpperCase() === 'MEDICAMENTOS') {
            return 'Medicamentos';
        } else if (tipo.toUpperCase() === 'PRESCRICOES') {
            return 'Prescrições';
        } else if (tipo.toUpperCase() === 'DIARIO DA SAUDE') {
            return 'Diário da saúde';
        }
    }

    getIconTipo(tipo) {
        if (tipo.toUpperCase() === 'ATENDIMENTO CLÍNICO') {
            return '/assets/imgs/icons/icon-atendimento.svg';
        } else if (tipo.toUpperCase() === 'RESULTADO DE EXAMES') {
            return '/assets/imgs/icons/icon-exames.png';
        } else if (tipo.toUpperCase() === 'SUMÁRIO DE ALTA') {
            return '/assets/imgs/icons/icon-internacao.png';
        } else if (tipo.toUpperCase() === 'REGISTROS DE VACINA') {
            return '/assets/imgs/icons/icon-vacina.png';
        } else if (tipo.toUpperCase() === 'MEDICAMENTOS') {
            return '/assets/imgs/icons/icon-medicamentos_2.png';
        } else if (tipo.toUpperCase() === 'PRESCRICOES') {
            return '/assets/imgs/icons/prescricoes.png';
        } else if (tipo.toUpperCase() === 'DIARIO DA SAUDE') {
            return '/assets/icons/cardio.svg';
        }
    }

    fechar() {
        this.modalController.dismiss();
    }

    // async getDetalhe(atendimento) {
    //     const detalhe = await this.document.loadDetail(atendimento);
    //     console.log(detalhe);
    //     this.list = detalhe;
    //
    //     //debugger;
    // }

    getTemplate(item) {
        const arr = Object.values(item);
        let element = '';
        arr.forEach(cont => {
            if (!cont['value']) {
                element += this.getElementRecursive(cont);
            }
        });
        return element;
    }

    getElementRecursive(item, interation = 0) {
        let element = '';

        element += '<div class="lb-interation-' + interation + '">';
        if (item.name && !item.value) {
            element += '<p class="lb-title-recursive lb-interation-' + interation + '">' + this.decodeUtf(item.name.value) + '</p>';
        }
        if (item.name && item.value) {
            element += '<p class="lb-result">' +
                this.decodeUtf(item.name.value) + ' <br> <span>' + this.decodeUtf(item.value.value) + '</span></p>';
        }
        const arr = Object.values(item);
        interation++;
        arr.forEach(cont => {
            if (cont['value'] && cont['name']) {
                let decode = '';
                element += '<p class="lb-result">' +
                    this.decodeUtf(cont['name']['value'])
                    + ' <br> <span>' +
                    this.decodeUtf(cont['value']['value'])
                    + '</span></p>';
            }
            if (!cont['value']) {
                element += this.getElementRecursive(cont, interation);
            }
        });
        element += '</div>';
        return element;
    }

    decodeUtf(data) {
        let decode = data;
        if (typeof data === 'string') {
            decode = utf8.decode(data);
        }
        return decode;
    }

    async downloadExame() {
        await this.document.download(this.atendimento);
    }

}
